module.exports = __webpack_public_path__ + "img/about-matt.f20054aa.jpg";